import { Injectable } from '@angular/core';
import { Auth } from 'aws-amplify';
import { PermissionsService } from '../../core/services/permissions.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {

  constructor(private permissionsService: PermissionsService) {}

  async register(data: { email: string; password: string }) {
    return Auth.signUp({
      username: data.email,
      password: data.password,
      attributes: { email: data.email },
    });
  }

  confirmRegister(email: string, code: string) {
    return Auth.confirmSignUp(email, code);
  }

  resendRegisterCode(email: string) {
    return Auth.resendSignUp(email);
  }

  async login(email: string, password: string) {
    const result = await Auth.signIn(email, password);
    
    // No inicializar permisos aquí, se hará cuando se guarde userData
    // La inicialización se debe hacer desde donde se guarda la información del usuario
    
    return result;
  }

  async logout() {
    // Limpiar permisos al cerrar sesión
    this.permissionsService.clearPermissions();
    
    // Limpiar localStorage
    localStorage.removeItem('userData');
    sessionStorage.removeItem('currentUser');
    
    return Auth.signOut();
  }

  getCurrentUser() {
    return Auth.currentAuthenticatedUser();
  }

  isAuthenticated(): Promise<boolean> {
    return Auth.currentAuthenticatedUser()
      .then(() => true)
      .catch(() => false);
  }

  forgotPassword(email: string) {
    return Auth.forgotPassword(email);
  }

  forgotPasswordSubmit(
    email: string,
    code: string,
    newPassword: string
  ) {
    return Auth.forgotPasswordSubmit(email, code, newPassword);
  }

  getCurrentTenantId(): string {
    try {
      const currentUser = sessionStorage.getItem('currentUser');
      if (currentUser) {
        const user = JSON.parse(currentUser);
        return user.tenantId || 'notaria_147'; // fallback por defecto
      }
      return 'notaria_147'; // fallback si no hay usuario en session
    } catch (error) {
      console.error('Error obteniendo tenantId del sessionStorage:', error);
      return 'notaria_147'; // fallback en caso de error
    }
  }

  /**
   * Actualizar datos del usuario y sus permisos
   */
  updateUserData(userData: any): void {
    localStorage.setItem('userData', JSON.stringify(userData));
    
    if (userData.assignedRoles) {
      this.permissionsService.updatePermissions(userData.assignedRoles);
    }
  }

  /**
   * Inicializar permisos en caso de que el usuario ya esté autenticado
   */
  initializeUserPermissions(): void {
    const userData = JSON.parse(localStorage.getItem('userData') || '{}');
    if (userData && userData.assignedRoles) {
      this.permissionsService.updatePermissions(userData.assignedRoles);
    }
  }
}
